export default __webpack_public_path__ + "static/media/google_podcast.9dc349d1.svg";